import { getAuthData } from "../../services/AuthService";


export interface iEndUserFilter {
    EndUser: string;
    CustomerID: number;
    Region: string;
    readonly Reader: string;
}

export class EndUserFilter {
    EndUser: string;
    CustomerID: number;
    Region: string;
    readonly Reader: string;

    constructor();
    constructor(obj: iEndUserFilter);	
    constructor(obj?: iEndUserFilter) { 
        this.EndUser = obj?.EndUser ?? "";
        this.CustomerID = obj?.CustomerID ?? 0;
        this.Region = obj?.Region ?? "ALL";
        this.Reader = getAuthData()?.userName ?? "";    
    }
}